module.exports = __webpack_public_path__ + "img/alfie-m8.0bc82af1.jpeg";